import { useEffect, useSyncExternalStore } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { hasProductTour, mountProductTour, subscribeToProductTour } from './product-tour';
import type { TourId } from './tours';

export function useHasProductTour() {
    return useSyncExternalStore(subscribeToProductTour, hasProductTour, () => false);
}

export function useProductTour(tourId: TourId, name: string | undefined) {
    const intl = useIntl();
    const { user } = useAuth();
    const { pathname } = useLocation();
    const userId = user?.id;

    useEffect(() => {
        if (name === undefined) return;
        return mountProductTour({
            tourId, intl, userId,
            values: tourId === 'manage-hub' ? { homeName: name } : { groupName: name },
        });
    }, [tourId, name, intl, userId, pathname]);
}
